import request from '@/util/request';

export const getList = (current, size, params) => {
  return request({
    url: '/api/feetemppay/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    },
  });
};
export const getTotalAmount = (params) => {
  return request({
    url: '/api/feetemppay/getTotalAmount',
    method: 'get',
    params: {
      ...params,
    },
  });
};

export const getDetail = (id) => {
  return request({
    url: '/api/feetemppay/detail',
    method: 'get',
    params: {
      id,
    },
  });
};

export const remove = (ids) => {
  return request({
    url: '/api/feetemppay/remove',
    method: 'post',
    params: {
      ids,
    },
  });
};

export const add = (row) => {
  return request({
    url: '/api/feetemppay/save',
    method: 'post',
    data: row,
  });
};

export const update = (row) => {
  return request({
    url: '/api/feetemppay/refund',
    method: 'post',
    data: row,
  });
};

//二维码支付
export const saveQrCodePay = (params, options) =>
  request.post('/api/feetemppay/qrCodePay', params, options);
//条形码支付
export const saveBarCodePay = (params, options) =>
  request.post('/api/feetemppay/barCodePay', params, options);
//查询支付状态
export const loadPayStatus = (params, options) =>
  request.get('/api/feetemppay/qrCodePayStatus', Object.assign({}, options, { params }));
